<div data-test-id="message-dialog-content" mat-dialog-content class="p-3">
  @if (data.templateMessage) {
    <ng-container *ngTemplateOutlet="data.templateMessage"></ng-container>
  } @else {
    <p data-test-id="message-dialog-p" class="font-weight-500">{{ data && data.textMessage ? data.textMessage : '' }}</p>
  }
</div>
<div data-test-id="message-dialog-actions" mat-dialog-actions class="justify-content-end text-right p-3">
  <button data-test-id="message-dialog-btn" class="btn btn-primary px-4" [mat-dialog-close]="false"
  cdkFocusInitial>Ok</button>
</div>


